/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { ScoreCardRetrieveWithWeight } from "./ScoreCardRetrieveWithWeight"

export type ScoreCardSetRetrieve = {
  readonly created_at: string
  created_by: string
  readonly version: string
  /**
   * Marks the active version of several instances of a ScoreCardSet
   */
  is_active_version?: boolean
  scorecards: Array<ScoreCardRetrieveWithWeight>
  /**
   * * `VALUE_BY_WEIGHT` - Value by Weight
   * * `NORMALIZED_VALUE_BY_WEIGHT` - Normalized value by weight
   */
  calculation_method?: ScoreCardSetRetrieve.calculation_method
}
export namespace ScoreCardSetRetrieve {
  /**
   * * `VALUE_BY_WEIGHT` - Value by Weight
   * * `NORMALIZED_VALUE_BY_WEIGHT` - Normalized value by weight
   */
  export enum calculation_method {
    VALUE_BY_WEIGHT = "VALUE_BY_WEIGHT",
    NORMALIZED_VALUE_BY_WEIGHT = "NORMALIZED_VALUE_BY_WEIGHT",
  }
}
